import React from 'react';

const SECTIONS = [
  {
    title: 'Information we collect',
    body: [
      'When you book an appointment, request a callback or send us a message, we collect the details you enter, such as your name, email address, phone number, city, the service you are interested in, your preferred date and time, indicative investment range and any message you write.',
      'We also collect basic technical information (such as browser type and pages visited) through analytics tools to understand how the website is used.',
    ],
  },
  {
    title: 'How we use your information',
    body: [
      'To respond to your enquiry, schedule and conduct consultations, and communicate with you about the services you asked about.',
      'To meet legal and regulatory obligations applicable to an AMFI-registered Mutual Fund Distributor.',
      'We do not sell your personal information.',
    ],
  },
  {
    title: 'Sharing of information',
    body: [
      'If you choose to invest, the information required for KYC and transactions is shared with Asset Management Companies, Registrar and Transfer Agents, KYC registration agencies and transaction platforms as needed to process your request.',
      'We may disclose information where required by law, regulation or a competent authority.',
    ],
  },
  {
    title: 'How we protect your information',
    body: [
      'We use reasonable technical and organisational measures to protect your information against unauthorised access, loss or misuse. Access is limited to people who need it to serve you.',
    ],
  },
  {
    title: 'Retention',
    body: ['We keep your information only for as long as needed for the purposes above or as required by applicable laws and regulations.'],
  },
  {
    title: 'Your choices and rights',
    body: [
      'Subject to applicable law, including the Digital Personal Data Protection Act, 2023, you may ask to access, correct or delete your personal information, or withdraw your consent to be contacted, by emailing cs@impetusinvestments.in.',
    ],
  },
  {
    title: 'Contact',
    body: [
      'Impetus Investment Services, New No. 28, Old No. 70, Ground Floor, Spur Tank Road, M.S. Nagar, Chetpet, Chennai – 600031. Email: cs@impetusinvestments.in. Phone: 98417 90000 / 73058 35581.',
      'Data protection contact: [Name and email – to be provided by Impetus Investment Services]',
    ],
  },
];

const PrivacyPolicy = () => (
  <div className="min-h-screen" data-testid="privacy-page">
    <section className="pt-32 pb-16 bg-[#FDF8F5]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-medium text-[#A0451E] mb-4" data-testid="privacy-heading">
          Privacy Policy
        </h1>
        <p className="text-sm font-body text-[#737373]">Last updated: 27 October 2026</p>
      </div>
    </section>
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
        <p className="text-base font-body text-[#4A4A4A] leading-relaxed">
          This policy explains how Impetus Investment Services ("we", "us") collects, uses and protects the personal information you share
          through this website.
        </p>
        {SECTIONS.map((s, i) => (
          <div key={s.title} data-testid={`privacy-section-${i}`}>
            <h2 className="text-xl font-heading font-medium text-[#A0451E] mb-3">{s.title}</h2>
            <div className="space-y-2 text-sm font-body text-[#4A4A4A] leading-relaxed">
              {s.body.map((p) => (
                <p key={p}>{p}</p>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  </div>
);

export default PrivacyPolicy;
